import { saveAs } from 'file-saver'

const DEFAULT_PDF_EXPORT_NAME = 'export_visit.pdf';

export const useVisitExport = () => {
    const onDownload = ({
        projectId,
        projectName,
        jwt,
        surveySvtIds,
        setLoading,
    }: {
        projectId: string
        projectName: string
        jwt: string
        surveySvtIds?: string[]
        setLoading: (loading: boolean) => void
    }) => {
        const queryString = surveySvtIds.map((id) => `surveySvtIds=${id}`).join('&')
        const filename = !projectName ? DEFAULT_PDF_EXPORT_NAME : `${projectName}.pdf`
        try {
            ;(window as any).webkit.messageHandlers.downloadFromUrl.postMessage({
                url: `${
                    process.env.REACT_APP_BASE_URL_BE
                }/projectsapi/activities/export/${projectId}${
                    surveySvtIds.length ? '?' + queryString : ''
                }`,
                filename,
                hasToken: true,
                isSplitFile: false,
            })
        } catch (error) {
            setLoading(true)
            fetch(
                `${process.env.REACT_APP_BASE_URL_BE}/projectsapi/activities/export/${projectId}${
                    surveySvtIds.length ? '?' + queryString : ''
                }`,
                {
                    method: 'GET',
                    headers: {
                        Accept: 'application/pdf',
                        'Content-Type': 'application/json', // Adatta il Content-Type ai dati che invii, es. 'application/json'
                        Authorization: 'Bearer ' + jwt,
                    },
                    // body: JSON.stringify({
                    //     surveySvtIds: surveySvtIds || [],
                    // }),
                }
            )
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Errore nella risposta del server')
                    }
                    return response.blob()
                })
                .then((res) => {
                    saveAs(
                        new Blob([res], { type: 'text/plain;charset=utf-8' }),
                        filename
                    )
                })
                .finally(() => setLoading(false))
        }
    }

    return { onDownload }
}
